export default "__VITE_ASSET__Dib6V7cJ__"